import * as React from 'react';
import { SVGProps } from 'react';

const IconAreaChartSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.8 6.95 1 4.15V15h14V4.15h-2.1L9.75 1 3.8 6.95Zm9.2 3.165V6.15h-.928L9.75 3.828 3.8 9.778l-.8-.8v3.115l.8.792L9.75 7l3.15 3.115h.1Z"
    />
  </svg>
);
export default IconAreaChartSizeS;
